export enum CampaignStatus {
  Scheduled = 1,
  InProgress = 2,
  Completed = 3,
  Cancel = 4,
}

export enum CampaignSource {
  Rules = 1,
  Report = 2,
  Clients = 3,
}

export enum SmsVendor {
  Bandwidth="Bandwidth",
  SMSIndia="SMSIndia",
  Others="Others",
}

export enum CampaignExecutionType
{
    Campaign = 1,
    Automation = 2,
}

export enum ClickAction
    {
        OpenApp = 1,          // Opens the app's home screen
        OpenSpecificPage = 2, // Navigates to a specific page within the app
        OpenURL = 3,          // Opens a given URL in a browser
        DeepLink = 4,         // Opens a deep link inside the app
        ViewProfile = 5,      // Navigates to a user's profile
        ViewNotification = 6, // Opens the notification details
        ViewTransaction = 7,  // Opens a transaction history/details page
        CustomAction = 8      // Custom action based on additional data in payload
    }
export enum PushNotificationPriority
    {
        High = 1,  // Push notification is delivered immediately
        Normal = 2 // Delivered at a lower priority
    }




